import { useRef, useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import html2canvas from "html2canvas";
import {UrlServicesEUACQUIS,Filter,URLPortal} from "../../.config";
import { loadModules } from "esri-loader";
import downloadjs from 'downloadjs';

const VisorExport = (props) => {

    var view = null;
    var webmap = null;
    const [webMap, setWebMap] = useState(null);
    const [viewMap, setViewMap] = useState(null);
    const mapEl = useRef(null);
    const print = async () => {
        //var iframes = document.querySelector("iframe"); //te da los Iframes de la pagina
        var iframes = document.getElementById("dashboard");
        var iframeDocument = iframes.contentWindow.document;
        var contenido = iframeDocument.body;
        contenido.querySelectorAll(".header-panel").forEach(e => e.remove());
        
        const canvas = await html2canvas(contenido);
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, 'download.png', 'image/png');
    };

    useEffect(() => {
        loadModules(["esri/identity/IdentityManager","esri/views/MapView", "esri/WebMap","esri/Map", "esri/config", "esri/widgets/Expand", "esri/layers/GraphicsLayer", "esri/widgets/Legend","esri/widgets/BasemapGallery", "esri/widgets/LayerList",
        "esri/widgets/Sketch", "esri/widgets/Print", "esri/widgets/CoordinateConversion", "esri/widgets/Bookmarks", "esri/widgets/ScaleBar", "esri/rest/identify", "esri/rest/support/IdentifyParameters", 
        "esri/widgets/DistanceMeasurement2D", "esri/widgets/AreaMeasurement2D", "esri/widgets/Home", 'esri/widgets/Sketch/SketchViewModel', 'esri/Graphic', 
        "esri/layers/FeatureLayer", "esri/widgets/FeatureTable", "esri/widgets/TimeSlider","esri/rest/support/Query","esri/renderers/HeatmapRenderer", "esri/rest/query"], {
          css: true
        }).then(([IdentityManager,MapView, WebMap,Map, esriConfig, Expand, GraphicsLayer, Legend, BasemapGallery, LayerList,
          Sketch, Print, CoordinateConversion, Bookmarks, ScaleBar, identify, IdentifyParameters, 
          DistanceMeasurement2D, AreaMeasurement2D, Home, SketchViewModel, Graphic,
          FeatureLayer, FeatureTable, TimeSlider,Query,HeatmapRenderer,query]) => {
          // then we load a web map from an id
          
          var bikeTrailsRenderer = {
            type: "simple",
            symbol: {
                type: "simple-line",
                style: "solid",
                color: [0, 255, 255, 0.8],
                width: "10px",
                outline: {
                    width: 10,
                    color: "#FFFF00"
                }
            }
          };
          esriConfig.portalUrl = URLPortal["UrlPortal"];
          const graphicsLayer = new GraphicsLayer({title:'Layer Draw'});
          const graphicsLayer2 = new GraphicsLayer({title:'Layer Selection Spatial'});
          var activeWidget = null;
          console.log(props.dataDashboard);
          if(props.dataDashboard)
          {
            IdentityManager.registerToken({
              server: URLPortal["UrlServicioToken"],
              token: props.dataDashboard[0].token
            });            
            console.log(props.dataDashboard[0].service)
          }
          webmap = new Map({
            basemap: "topo-vector"
          });
        
         /* webmap = new WebMap({
            portalItem: {            
              id : '20f157bf699a42e5b13f315dafb7dcba'//'0cf63cbbac03415197845ea173087851'//'66611fe0654d490996e4f463a9826e89'//'a589237dd7db4a279c5ca24ce1ae6329'// get item id from the props
            }
          });*/
          setWebMap(webmap);
          window.webmap = webmap;
          view = new MapView({
            map: webmap,
            container: mapEl.current
          });
          window.view = view;
         
          function createFillSymbol(value, color) {
            return {
              "value": value,
              "symbol": {
                "color": color,
                "type": "simple-fill",
                "style": "solid",
                "outline": {
                  "style": "none"
                }
              },
              "label": value
            };
          }
          if(props.dataDashboard){
          const Border = new FeatureLayer({
            url: UrlServicesEUACQUIS["ServicesBorderMapServer"],
            insertIndex: 3,
          });
          webmap.add(Border); 

          const City = new FeatureLayer({
            url: UrlServicesEUACQUIS["Servicescity"],
            insertIndex: 2,
          });
          webmap.add(City);      
          var arrayrp = [];
          const openSpacesRenderer = {
            type: "unique-value",
            field: "country_code",
            uniqueValueInfos: arrayrp 
          };
      
          const Boundaries = new FeatureLayer({
          url: UrlServicesEUACQUIS["ServicesBorderMapServer"],
                renderer: openSpacesRenderer,
                opacity: 0.5,
                insertIndex: 1,
          });
            
          webmap.add(Boundaries); 
    
          const querydata = new Query();
          querydata.where = "1=1";
    
          Boundaries.queryExtent(querydata).then(function(results){
                view.goTo(results.extent);  // go to the extent of the results satisfying the query
          });
        }
          if(props.dataDashboard){
            //sin funciona las capas colocamos props.dataDashboard[0].url
            //sin funciona las capas colocamos props.dataDashboard[0].ids esto aplicar el concatenar
            var FilterRaiz = "";
            if(Filter[props.dataDashboard[0].layerId])
            {
              FilterRaiz = Filter[props.dataDashboard[0].layerId];
            }
            const Filtro = `(${props.dataDashboard[0].ids.join(', ')})`;
            console.log(Filtro);//este filtro va en definitionExpression
            const CapaMostrar = new FeatureLayer({
              url: props.dataDashboard[0].service,
              definitionExpression: FilterRaiz+props.dataDashboard[0].layerId+" in "+(Filtro)+""
            });
            webmap.add(CapaMostrar);
          }        

          var homeWidget = new Home({
            view: view
          });
  
          view.ui.add(homeWidget, "top-left");
  
          const baseMap = new Expand({
            view,
            content: new BasemapGallery({ view }),
            expandIconClass: "esri-icon-basemap",
            expandTooltip: "Open base maps gallery",
            group: "apps-top"
          });
          view.ui.add(baseMap, "bottom-trailing");
  
          const legend = new Expand({
            content: new Legend({ view }),
            view,
            expandIconClass: "esri-icon-legend",
            expandTooltip: "Legend",
            group: "apps-top"
          });
          view.ui.add(legend, "bottom-trailing");
  
          const layerList = new Expand({
            content: new LayerList({ view }),
            view,
            expandIconClass: "esri-icon-layers",
            expandTooltip: "Display the list of layers",
            group: "apps-top"
          });
          view.ui.add(layerList, "bottom-trailing");
  
          const bookMark = new Expand({
            content: new Bookmarks({
              view: view,
              editingEnabled: true,
              visibleElements: {
                time: false // don't show the time (h:m:s) next to the date
              }
            }),
            view,
            expandIconClass: "esri-icon-bookmark",
            expandTooltip: "Add a bookmark",
            group: "apps-top"
          });
          view.ui.add(bookMark, "bottom-trailing");
  
          const sketch = new Expand({
            content: new Sketch({ layer: graphicsLayer, view, creationMode: "update" }),
            view,
            expandIconClass: "esri-icon-edit",
            expandTooltip: "Create and annotate shapes or markers on the map",
            group: "apps-top"
          });
          view.ui.add(sketch, "bottom-trailing");

          const print = new Expand({
            content: new Print({ view, printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task" }),
            view,
            expandIconClass: "esri-icon-printer",
            expandTooltip: "Print the current map view",
            group: "apps-top"
          });
          
          view.ui.add(print, "bottom-trailing");
          
          const scaleBar = new ScaleBar({
            view: view,
            unit: "dual", // The scale bar displays both metric and non-metric units.
            expandTooltip:"Restore map view"
          });
  
          // Add the widget to the bottom left corner of the view
          view.ui.add(scaleBar, { position: "bottom-left"});
  
          view.when(function() {
            let popup = view.popup;
            popup.viewModel.on("trigger-action", event => {
                //console.log(popup.viewModel.selectedFeature);
                if (event.action.id === "openFileProject") {
                  var attributes = popup.viewModel.selectedFeature.attributes;
                  var id = attributes["npm_road_id"];
                  attributes.countryCode = attributes.country_code;
                  props.requestData(attributes);
                  var element = document.getElementById("tblResult");
                  document.getElementById("tblResult").innerHTML = "";
                  document.getElementById("tblResult").style.display = "none";
                  element.classList.remove("table-size");
                  props.expandingResultTable(false);
                  props.expanding();
                }
            });
          });
  
        });
        return () => {
          if (!!view) {
            view.destroy();
            view = null;
          }
        };
  
      }, [props.dataDashboard])
return (
  <Container fluid >
  <div style={{ height: "calc(90vh - 100px)", width:"100%" }}  ref={mapEl} />
  </Container>
    )
}

export { VisorExport };